
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/erpcige/cigeerp",
      function () {
        return require("private-next-pages/erpcige/cigeerp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/erpcige/cigeerp"])
      });
    }
  